import { legacyContractAttrs, legacyHookAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { selectAccessState, selectMainState } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'
import { LockedScreen } from '@/deskUiSkeletons/Blocking/LockedScreen'

export function PooMainDocument() {
  const { state } = useSubsStore()
  const main = selectMainState(state)
  const access = selectAccessState(state)
  const protocol = state.pooProtocol
  const title = main.subject || main.title || 'OPP document'
  const content = protocol?.fullContent

  return (
    <article {...legacyHookAttrs('main.root', 'mb-6 overflow-hidden rounded-xl border border-[#d7d1c5] bg-white shadow-[0_1px_4px_rgba(28,40,36,0.07)]')}>
      <header {...legacyHookAttrs('main.header', 'border-b border-[#e6e1d8] px-5 py-4 sm:px-7')}>
        <div className="flex min-w-0 items-start justify-between gap-5">
          <div className="min-w-0">
            <div {...legacyHookAttrs('main.avatarFrame', 'hidden')} hidden aria-hidden="true"><img {...legacyContractAttrs('main.avatarImage')} alt="" /></div>
            <span {...legacyHookAttrs('main.nameKeySign', 'hidden')} hidden aria-hidden="true">@</span>
            <span {...legacyHookAttrs('main.authorFrame', 'text-[11px] font-semibold uppercase tracking-[0.18em] text-[#557168]')}>{main.author || main.nameKey || 'msgdesk OPP document'}</span>
            <div {...legacyHookAttrs('main.emailRegion', 'hidden')} hidden aria-hidden="true" />
            <div {...legacyHookAttrs('main.subjectRegion', 'mt-1.5')}><div {...legacyHookAttrs('main.subjectLine', '')}><h1 {...legacyHookAttrs('main.subjectText', 'break-words font-serif text-2xl font-semibold leading-tight text-[#1b2824] sm:text-3xl')}>{title}</h1></div></div>
          </div>
          <span {...legacyHookAttrs('main.datetime', 'flex-none text-xs text-[#77807c]')}>{main.datetime || ''}</span>
        </div>
      </header>
      <div {...legacyHookAttrs('main.quad', 'px-5 py-5 sm:px-7 sm:py-6')}>
        <div {...legacyHookAttrs('main.body', 'relative')}>
          <div className="mb-4 inline-flex rounded-full bg-[#edf3f0] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#436359]">{content ? 'Part 2 · unlocked' : 'Part 1 · preview'}</div>
          <div {...legacyHookAttrs('main.iframe', 'max-w-4xl text-[15px] leading-7 text-[#34413c]')}>
            {/* LOCKED-SCREEN: a pin/time lock on the msg itself precedes the
                PoO Part 1/2 protocol presentation (which seals only Part 2). */}
            {!access.showUnlocked ? <LockedScreen /> : content ? <div className="whitespace-pre-wrap break-words">{content.body}</div> : (
              <div>
                <p className="whitespace-pre-wrap break-words">{protocol?.preview || 'No public preview was supplied.'}</p>
                <p className="mt-4 rounded-md border border-[#ded9cf] bg-[#f7f5f0] px-4 py-3 text-sm text-[#68716d]">Part 2 remains sealed until the recipient completes Opening Proof and secure notification is accepted.</p>
              </div>
            )}
          </div>
        </div>
        <div {...legacyHookAttrs('main.editMount', 'hidden')} hidden aria-hidden="true" />
      </div>
    </article>
  )
}
